import { useSelector } from "react-redux";

/**
 * Get Loading state of any redux slice
 * @param {string} slices comma separated redux slice 
 * @returns {boolean}
 */
const useIsLoading = slices => {

    const isLoading = useSelector(state => (slices?.replace(/ /g, "")?.split(",") || []).some(item => !!state[item]?.isLoading));

    return isLoading;
}

export default useIsLoading;